import { TodistuksetUi } from 'todistukset-ui/src/vtj/common-types'
import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'
import CertificateSubtypes from 'todistukset-common/src/vtj/CertificateSubtypes.enum'
import type { Serialized } from 'common/src/vtj/types/util.type'
import type { TodistusOrder } from 'todistukset-common/src/vtj/types/todistus-order.type'

// Like Serialized<TodistusOrder>, but making form.paymentId
// and form.todistusSubtype mandatory.
export type PreviousOrder = {
  form: Serialized<TodistusOrder>['form'] & {
    paymentId: number
    todistusSubtype: CertificateSubtypes
  }
  payment: Serialized<TodistusOrder>['payment']
}

export function getOrder(
  store: TodistuksetUi.Store,
  paymentId: string | undefined
): PreviousOrder | undefined {
  function isPreviousOrder(
    item: Serialized<TodistusOrder>
  ): item is PreviousOrder {
    const todistusSubtype: unknown = item?.form?.todistusSubtype
    return (
      typeof item?.form?.paymentId === 'number' &&
      Object.values<unknown>(CertificateSubtypes).includes(todistusSubtype)
    )
  }
  return store.previousOrders
    .filter(isPreviousOrder)
    .find((item) => paymentId && String(item.form.paymentId) === paymentId)
}

export function doesOrderExist({
  store,
  certificateType,
  paymentId,
}: {
  store: TodistuksetUi.Store
  certificateType: CertificateTypes
  paymentId: string | undefined
}): boolean {
  if (certificateType === CertificateTypes.UAETTODISTUS) {
    return !!store.uaetOrders.find(
      (uaetOrder) => uaetOrder.payment?.paymentId?.toString() === paymentId
    )
  }
  const order = getOrder(store, paymentId)
  return !!order && order.form.todistusType === certificateType
}
